import { GroupQuote } from '@/views/group-quotation-list/group-quotation-list.types';

export interface State {
  loading: boolean;
  quotes: GroupQuote[];
}

const state: State = {
  loading: false,
  quotes: [],
};

export default state;
